import React from 'react';
import classNames from 'classnames';
import config from 'utils/config';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import Hidden from '@material-ui/core/Hidden';
import Popper from '@material-ui/core/Popper';
import Divider from '@material-ui/core/Divider';

// @material-ui/icons
import Person from '@material-ui/icons/Person';

// core components
import Button from 'components/CustomButtons/Button';

import styles from 'assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle';

//sevis imports
import AuthService from 'services/auth.service';
import { store } from 'plugins/store/store';
import { useHistory } from 'react-router-dom';
import { setAlertActionCreator } from 'plugins/store/reducers/common.reducer';
import layoutNames from 'utils/enums/layout-names.enum';

const useStyles = makeStyles(styles);

export default function HeaderLinks() {
	const [openProfile, setOpenProfile] = React.useState(null);
	const handleClickProfile = (event) => {
		if (openProfile && openProfile.contains(event.target)) {
			setOpenProfile(null);
		} else {
			setOpenProfile(event.currentTarget);
		}
	};
	const handleCloseProfile = () => {
		setOpenProfile(null);
	};
	const history = useHistory();
	const handleLogout = () => {
		AuthService.logout();
		history.push(`/${layoutNames.auth}/login`);
	};
	const handleAboutClick = () => {
		const appName = config.appName || 'eCallMe! - License Portal';
		const appVersion = config.appVersion || '0.0.0.1';
		store.dispatch(
			setAlertActionCreator({
				type: 'info',
				title: 'About',
				children: (<div>
					<div>{appName}</div>
					<div>Version {appVersion}</div>
				</div>),
				onConfirm: () => {
					store.dispatch(setAlertActionCreator(null));
				},
			})
		);
	};
	const handleProfileClick = () => {
		history.push(`/${layoutNames.portal}/profile`);
	};
	const classes = useStyles();
	const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover);
	const managerClasses = classNames({
		[classes.managerClasses]: true,
	});
	return (
		<div>
			<div className={managerClasses}>
				<Button
					color="transparent"
					aria-label="Person"
					justIcon
					aria-owns={openProfile ? 'profile-menu-list' : null}
					aria-haspopup="true"
					onClick={handleClickProfile}
					className={classes.buttonLink}
					muiClasses={{
						label: '',
					}}
				>
					<Person
						className={classes.headerLinksSvg + ' ' + classes.links}
					/>
					<Hidden mdUp implementation="css">
						<span
							onClick={handleClickProfile}
							className={classes.linkText}
						>
							{'Profile'}
						</span>
					</Hidden>
				</Button>
				<Popper
					open={Boolean(openProfile)}
					anchorEl={openProfile}
					transition
					disablePortal
					placement="bottom"
					className={classNames({
						[classes.popperClose]: !openProfile,
						[classes.popperResponsive]: true,
						[classes.popperNav]: true,
					})}
				>
					{({ TransitionProps }) => (
						<Grow
							{...TransitionProps}
							id="profile-menu-list"
							style={{ transformOrigin: '0 0 0' }}
						>
							<Paper className={classes.dropdown}>
								<ClickAwayListener
									onClickAway={handleCloseProfile}
								>
									<MenuList role="menu">
										<MenuItem
											onClick={handleProfileClick}
											className={dropdownItem}
										>
											{'Profile'}
										</MenuItem>
										<MenuItem
											onClick={handleAboutClick}
											className={dropdownItem}
										>
											{'About'}
										</MenuItem>
										<Divider light />
										<MenuItem
											onClick={handleLogout}
											className={dropdownItem}
										>
											{'Log out'}
										</MenuItem>
									</MenuList>
								</ClickAwayListener>
							</Paper>
						</Grow>
					)}
				</Popper>
			</div>
		</div>
	);
}
